export const ecuadorFinancialInstitutions = [
  ['Banco Pichincha', 'Banco'],
  ['Banco Guayaquil', 'Banco'],
  ['Banco del Pacífico', 'Banco'],
  ['Produbanco', 'Banco'],
  ['Banco Internacional', 'Banco'],
  ['Banco Bolivariano', 'Banco'],
  ['Banco del Austro', 'Banco'],
  ['Banco General Rumiñahui', 'Banco'],
  ['Banco de Machala', 'Banco'],
  ['Banco de Loja', 'Banco'],
  ['Banco Solidario', 'Banco'],
  ['Banco ProCredit', 'Banco'],
  ['Banco Diners Club', 'Banco'],
  ['BanEcuador', 'Banco público'],
  ['Cooperativa JEP', 'Cooperativa'],
  ['Cooperativa Jardín Azuayo', 'Cooperativa'],
  ['Cooperativa Policía Nacional', 'Cooperativa'],
  ['Cooperativa 29 de Octubre', 'Cooperativa'],
  ['Cooperativa Alianza del Valle', 'Cooperativa'],
  ['Cooperativa Andalucía', 'Cooperativa'],
  ['Cooperativa Atuntaqui', 'Cooperativa'],
  ['Cooperativa Oscus', 'Cooperativa'],
  ['Cooperativa Riobamba', 'Cooperativa'],
  ['Cooperativa San Francisco', 'Cooperativa'],
  ['Cooperativa Mushuc Runa', 'Cooperativa'],
  ['Mutualista Pichincha', 'Mutualista'],
  ['Mutualista Azuay', 'Mutualista'],
] as const;
